var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("About")]),_c('p',[_vm._v(" This page sample app for "),_c('br'),_vm._v(" Vue.js , Vue-CLI + IndexedDB ")])])}]

export { render, staticRenderFns }